var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageCircleDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00132 11H9.01132V13H7.00132V11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0013 11H13.0113V13H11.0013V11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 11H17.0113V13H15.0013V11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00132 12C1.00132 5.92487 5.92618 1 12.0013 1C18.0765 1 23.0013 5.92487 23.0013 12C23.0013 18.0751 18.0765 23 12.0013 23C10.3286 23 8.74071 22.626 7.31896 21.9563L0.726562 23.2748L2.04504 16.6824C1.37535 15.2606 1.00132 13.6727 1.00132 12ZM12.0013 3C7.03075 3 3.00132 7.02944 3.00132 12C3.00132 13.4751 3.35545 14.8647 3.98244 16.091L4.14094 16.4009L3.27607 20.7252L7.60039 19.8604L7.91037 20.0189C9.13665 20.6459 10.5262 21 12.0013 21C16.9719 21 21.0013 16.9706 21.0013 12C21.0013 7.02944 16.9719 3 12.0013 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircleDots);
export default __webpack_public_path__ + "static/media/message-circle-dots.f5e0339a8e708ca00d80060af5f4c342.svg";
export { ForwardRef as ReactComponent };